import React from 'react';
import NewChatButton from './NewChatButton';
import ExpandChatButton from './ExpandChatButton';
import styles from '../ChatWidget.module.scss';
import nekstAiIcon from './nekstAiIcon.png';

interface ChatHeaderProps {
  onClose: () => void;
  onExpand: (conversationId: number | null) => void;
}

export default function ChatHeader(props: ChatHeaderProps) {
  return (
    <div className={styles.header} data-testid="chat-header">
      <div className={styles.headerInfo}>
        <div className={styles.headerAvatar}>
          <img src={nekstAiIcon} alt="Nekst AI" width={32} height={32} />
        </div>
        <div className={styles.headerText}>
          <div className={styles.headerTitle}>Nekst AI</div>
          <div className={styles.headerSubtitle}>Online</div>
        </div>
      </div>
      <div className={styles.headerActions}>
        <NewChatButton />
        <ExpandChatButton onExpand={props.onExpand} />
        <button
          type="button"
          className={styles.headerButton}
          onClick={props.onClose}
          aria-label="Close chat"
        >
          &times;
        </button>
      </div>
    </div>
  );
}
